import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, delay, map, mergeMap, of, retry, tap } from 'rxjs';

import { CustomersSuppliersSync, ProgressModel } from '@/customers-suppliers-import/models';
import { PollingStatus } from '@/tax/models';

import { environment } from '@env';

const DELAY_STATUS_FETCH_MS = 1000;
const invalidErrorMessage = 'Not ready';

@Injectable({ providedIn: 'root' })
export class CustomersSuppliersService {
    constructor(private http: HttpClient) { }

    createCustomersSuppliersSyncAndPollResult(
        orgId: number,
        companyId: number,
        sync: CustomersSuppliersSync,
        progress: ProgressModel,
    ): Observable<CustomersSuppliersSync> {
        return this.createCustomersSuppliersSync(orgId, companyId, sync).pipe(
            delay(DELAY_STATUS_FETCH_MS),
            mergeMap((newSync) =>
                this.getCustomersSuppliersSync(orgId, companyId, newSync.id).pipe(
                    tap((polled) => {
                        progress.progress = polled.progress;
                        if (polled.status === PollingStatus.Init || polled.status === PollingStatus.InProgress) {
                            throw Error(invalidErrorMessage);
                        }
                    }),
                    retry({
                        delay: (error) => {
                            if (error.message !== invalidErrorMessage) {
                                throw error;
                            } else {
                                return of(true).pipe(delay(DELAY_STATUS_FETCH_MS));
                            }
                        },
                    }),
                ),
            ),
        );
    }

    getCustomersSuppliersSync(orgId: number, companyId: number, syncId: number): Observable<CustomersSuppliersSync> {
        return this.http
            .get<any>(environment.endpoints.organisationCompaniesCustomersSuppliersSyncsDetails(orgId, companyId, syncId))
            .pipe(map<any, CustomersSuppliersSync>((sync) => new CustomersSuppliersSync().deserialize(sync)));
    }

    createCustomersSuppliersSync(orgId: number, companyId: number, sync: CustomersSuppliersSync): Observable<CustomersSuppliersSync> {
        const url = environment.endpoints.organisationCompaniesCustomersSuppliersSyncsList(orgId, companyId);
        return this.http.post<CustomersSuppliersSync>(url, sync.serialize())
            .pipe(map((s) => new CustomersSuppliersSync().deserialize(s)));
    }

}
